<template>
   <div class="flex flex-wrap items-center email-header justify-between md:px-8 px-6 sm:pb-2 sm: pt-6 d-theme-dark-bg mt-2" style="border-radius: 5px;">
        <div class="flex mb-4">
            <div class="flex items-center">
                <feather-icon icon="ArrowLeftIcon" class="cursor-pointer mr-4" svg-classes="w-6 h-6" @click="CloseSideBar"></feather-icon>
                <h4 class="lg" v-if="discipline">{{discipline.discipline.name}}</h4>
                <h4 class="lg" v-else>(no subject)</h4>
                <div class="xs" v-if="discipline">{{discipline.discipline.name}}</div>
                <div class="xs" v-else>(no subject)</div>
            </div>
        </div>
<!--        <div class="ml-10 mb-4 mt-1">-->
<!--            <div class="email__actions&#45;&#45;single flex items-center">-->
<!--                <feather-icon :icon="$vs.rtl ? 'ChevronsRightIcon' : 'ChevronsLeftIcon'" svg-classes="h-6 w-6" class="cursor-pointer ml-4 hidden sm:inline-flex" @click="$emit('previousMail')" />-->
<!--                <feather-icon :icon="$vs.rtl ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'" svg-classes="h-6 w-6" class="cursor-pointer ml-4 hidden sm:inline-flex mr-2" @click="$emit('nextMail')" />-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>

<script>
  import { mapMutations } from 'vuex'

export default {
    name:'SideBar',
    props:{
        discipline:{
            type:Object,
        }
    },
    methods: {

        ...mapMutations({
            isntActive:'regis_discepline_sidebar/CLEAR_SIDEBAR',
            clearDiscipline:'regis_discepline_sidebar/CLEAR_DISCIPLINE',
        }),

        CloseSideBar(){
            this.isntActive();
            this.clearDiscipline()
        }

    },

}
</script>
<style lang="scss">
@media (max-width: 540px){
    .lg{
        display: none;
    }
}
@media (width: 540px){
    .lg{
        display: contents;
    }
}
@media (min-width: 540px){
    .xs{
        display: none;
    }
}
</style>
